/* istanbul ignore file */
const React = require("internal-react");
const { use } = require("suite-storage");

React.defaultCreateContext = React.createContext;
React.defaultCreateElement = React.createElement;

React.createContext = (key, ...args) => {
	if (typeof key !== "string") {
		return React.defaultCreateContext(key);
	}
	return use(key, () => React.defaultCreateContext(...args));
};

React.createElement = (...args) => {
	if (typeof args[0] === "string" && args[1] && args[1].testId) {
		delete args[1].testId;
	}

	return React.defaultCreateElement(...args);
};

module.exports = React;